import { useEffect, useMemo, useState } from 'react';
import {
  Box,
  Card,
  CardContent,
  Checkbox,
  FormControlLabel,
  Autocomplete,
  TextField,
  Typography,
} from '@mui/material';
import { useMasterData } from '../../../contexts/DataProvider';
import { useSelector } from 'react-redux';

export function TimeTableFilter({
  defaultOnlyActive = true,
  defaultTeacherId = -1,
  onChange,
}) {
  const user = useSelector((s) => s.auth.user);
  const [onlyActive, setOnlyActive] = useState(defaultOnlyActive);
  const [teacherId, setTeacherId] = useState(
    user?.userType ? user?.ext_id_user : defaultTeacherId
  );
  const { oktato } = useMasterData(); // [{ id, text, active? }]

  const toArray = (ds) => {
    if (Array.isArray(ds)) return ds;
    if (ds?.items && Array.isArray(ds.items)) return ds.items;
    if (ds?.data && Array.isArray(ds.data)) return ds.data;
    if (ds?._items && Array.isArray(ds._items)) return ds._items;
    try {
      if (typeof ds?.toArray === 'function') return ds.toArray();
    } catch {}
    return [];
  };

  // normalizált opciók Autocomplete-hez
  const teacherOptions = useMemo(() => {
    const raw = toArray(oktato);
    return raw.map((t) => ({
      id: t.id ?? t.value ?? t.key,
      label:
        t.text ??
        t.label ??
        `${t.last_name ?? ''} ${t.first_name ?? ''}`.trim(),
      active: t.active ?? t.isActive ?? 1,
    }));
  }, [oktato]);

  const selectedTeacher = useMemo(
    () => teacherOptions.find((t) => t.id === teacherId) ?? null,
    [teacherOptions, teacherId]
  );

  useEffect(() => {
    onChange && onChange({ onlyActive, teacherId });
  }, [onlyActive, teacherId, onChange]);

  return (
    <Box component={Card} variant='outlined' sx={{ mb: 2 }}>
      <CardContent>
        <Typography variant='subtitle2' sx={{ opacity: 0.7, mb: 1 }}>
          Új órarend
        </Typography>
        <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
          <FormControlLabel
            control={
              <Checkbox
                checked={onlyActive}
                onChange={(e) => setOnlyActive(e.target.checked)}
              />
            }
            label='Csak az aktívak megjelenítése'
          />
          <Autocomplete
            sx={{ minWidth: 260 }}
            options={teacherOptions}
            value={selectedTeacher}
            onChange={(_e, value) =>
              setTeacherId(value ? Number(value.id) : -1)
            }
            renderInput={(params) => (
              <TextField {...params} label='Oktató választása' size='small' />
            )}
            clearOnEscape
            isOptionEqualToValue={(o, v) => !!v && o.id === v.id}
          />
        </Box>
      </CardContent>
    </Box>
  );
}
